import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
// import { Chart, registerables } from "chart.js";
import { Chart } from "primereact/chart";
import colors from "../../../config/colors";
import { color } from "@mui/system";

// Chart.register(...registerables);
const CompoundBarChart = ({ data }) => {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          labels: {
            color: color.black,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: colors.black,
          },
          grid: {
            color: "white",
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: colors.black,
          },
          grid: {
            color: "white",
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, [data]);

  return <Chart type="bar" data={chartData} options={chartOptions} />;
};

export default CompoundBarChart;
